module.exports = __webpack_public_path__ + "img/not-found.e4d4a4be.svg";